import React from 'react'
import { AllCategoryComponent } from './AllCategoryComponent'
import { Content, Footer, Header } from 'antd/es/layout/layout';
import { layoutStyle, headerStyle, contentStyle, footerStyle, rowStyle } from '../../assets/styles/stylesMain'
import { Layout } from 'antd';
// ======================================================================

export const AllCategoryLayoutComponent = ({
  setLoading,
  showMessage,
  parentId,
  isShowAddSubCategory,
  isShowEdit,
  editClick,
  isShowDelete,
  onRowDeleted,
  addSubCategoryClick,
  isLoadObjectInstanceCategories,
  isLoadCategoryFromParam,
  selectedCategory,
  isShowCheckBox,
  onCheckChange,
  objectInstanceId,
  onClickItems,

}) => {
  // ======================================================================
  return (
    <>
      <div className='sectionTitle'>
        <h2 >
          لیست دسته بندی ها
        </h2>
      </div>
      <div className='container'>
        <AllCategoryComponent
          setLoading={setLoading}
          showMessage={showMessage}
          parentId={parentId}
          isShowAddSubCategory={isShowAddSubCategory}
          isShowEdit={isShowEdit}
          editClick={editClick}
          isShowDelete={isShowDelete}
          onRowDeleted={onRowDeleted}
          addSubCategoryClick={addSubCategoryClick}
          isLoadObjectInstanceCategories={isLoadObjectInstanceCategories}
          isLoadCategoryFromParam={isLoadCategoryFromParam}
          selectedCategory={selectedCategory}
          isShowCheckBox={isShowCheckBox}
          onCheckChange={onCheckChange}
          objectInstanceId={objectInstanceId}
          onClickItems={onClickItems}
        />
      </div>

    </>
  )
}
